import React from 'react';

import { provinceOptionsCA } from 'src/services/location/constants/ca';
import Autocomplete from 'src/components/input/autocomplete/Autocomplete';

import styles from 'src/components/input/address/SelectStateUS.module.css';

type Props = Omit<React.ComponentProps<typeof Autocomplete>, 'options'>;

export default function SelectProvinceCA(props: Props) {
    return (
        <Autocomplete
            classes={{ root: styles.root, endAdornment: styles.endAdornment }}
            options={provinceOptionsCA}
            {...props}
            data-testid="province-field"
        />
    );
}
